export default {
  guide: {
    start: 'Commencer',
    whatsNext: 'Quelle est la suite ?',
    dontShowAgain: 'Ne plus afficher cette fenêtre contextuelle',
    needHelp: 'Besoin d’aide',
    userManual: 'Manuel utilisateur',
    chooseFormat: 'Choisissez votre format préféré',
    pdfManual: 'Manuel PDF',
    downloadPdf: 'Télécharger et lire hors ligne',
    videoTutorial: 'Tutoriel vidéo',
    watchStepByStep: 'Regarder le guide étape par étape',
    firstStepTitle: 'Bienvenue ! Nous vous guiderons à travers vos premières étapes.',
    activationKey: {
      title: 'Les nouvelles clés d’activation ont été enregistrées avec succès.',
      description:
        'Envoyez les clés d’activation aux agriculteurs/collecteurs de données afin qu’ils puissent s’inscrire sous votre organisation.',
      nextStep: 'Cliquez sur le bouton Action pour sélectionner le format avec lequel vous souhaitez partager les clés.',
    },
    dashboard: {
      userManagement: 'Gestion des utilisateurs',
      userManagementDescription: 'La section Gestion des utilisateurs vous permet de :',
      listUser: 'Afficher la liste actuelle des utilisateurs mobiles et administrateurs',
      addUser: 'Ajouter de nouveaux utilisateurs ou inviter des utilisateurs avec des clés d’activation',
      managePermission: 'Gérer les autorisations, les plans d’adhésion et les rôles',
      farmManagement: 'Gestion des exploitations',
      farmManagementDescription: 'Accédez à la section Gestion des exploitations pour :',
      listFarm: 'Afficher la liste des exploitations et des agriculteurs enregistrés',
      addFarm: 'Ajouter de nouvelles exploitations une par une ou en masse',
      title: 'Tableau de bord',
      description:
        'À mesure que vous intégrez davantage d’utilisateurs et d’exploitations, vous pourrez voir le récapitulatif sur le tableau de bord principal.',
    },
    ddsDashboard: {
      title: 'Commencez par la section « Créer un nouveau rapport de diligence raisonnable » pour démarrer.',
      alreadyHaveFarm: 'Vous avez déjà des données sur l’exploitation ?',
      description:
        'Vous aurez la possibilité d’ajouter les données de votre exploitation lors de la deuxième étape du processus « Créer un nouveau rapport de diligence raisonnable ».',
      createNewReport: 'Créer un nouveau rapport',
      creatingReport: 'Création d’un rapport de diligence raisonnable',
      sharingWithOperator: 'Partage avec l’opérateur',
      riskMitigation: 'Atténuation des risques',
    },
    productionPlace: {
      title: 'Téléchargez les données de votre exploitation',
      description: 'Téléchargez les données de votre exploitation une par une ou en masse en cliquant sur le bouton « Ajouter nouveau ».',
      allowedFormat: 'Actuellement, nous acceptons les formats suivants pour le téléchargement de données en masse :',
    },
    reportDetail: {
      title: 'Tout d’abord, veuillez renseigner les détails concernant votre rapport.',
      description: 'Besoin d’aide ? Consultez nos guides utilisateur (PDF ou vidéo) en cliquant ici :',
      nextStep: 'Une fois terminé, cliquez sur « Suivant » pour passer à l’étape où vous pourrez télécharger les données de production de votre exploitation.',
    },
    adminRegistered: {
      title: 'Le nouvel utilisateur administrateur a été enregistré avec succès.',
      description:
        'Envoyez les clés d’activation aux agriculteurs/collecteurs de données afin qu’ils puissent s’inscrire sous votre organisation.',
      nextStep: 'Quelle est la suite ? Commencez l’intégration des agriculteurs et des collecteurs de données.',
    },
  },
};
